module.exports = {
  general: {
    fontFamily: {
      en: 'Marselis',
      ar: 'GE Dinkum'
    },
    showArtistImpressionText: false,
    showOnHoldGraphic: true,
    showSoldPrice: false,
    canInteractSoldLivingOptions: true,
    canInteractSoldSubsections: true,
    canInteractSoldProperties: true,
    showSoldNeighbourhoods: true,
    showSoldReleases: true,    
    disclaimer: 'Content or information obtained from Sensoreal is accurate, complete or reliable at time of publishing. Information about land, homes, apartments, and land and house package prices. This information is to be used as a guide only. Any images and diagrams on the website should be used as a visual aid only and may not accurately reflect the development, the land and/or the house referred to or depicted. We may, from time to time and without notice, change or add to the Sensoreal or the information, products or services described in it.'
  },
  filter: {
    dwellings: {
      houseDesign: false
    }
  },
  landPage: {
    active: false
  },

  property_card: {
    price_label: {
      house_design: 'House Price From'
    }
  },

  property_modal: {
    show_suitable_dwellings_button: true
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: [
        'Available',
        'On Hold',
        'Sold'
      ]
    }
  },
  useSidebarSubnavigation: true
}